import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_http_status = _resolveComponent("http-status")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FullscreenLoading = _resolveComponent("FullscreenLoading")!

  return ([403, 404, 500].indexOf(_ctx.errorStore.status_code) >= 0)
    ? (_openBlock(), _createBlock(_component_http_status, {
        key: 0,
        "status-code": _ctx.errorStore.status_code,
        detail: _ctx.errorStore.detail,
        endpoint: _ctx.errorStore.endpoint
      }, null, 8, ["status-code", "detail", "endpoint"]))
    : (_openBlock(), _createBlock(_component_FullscreenLoading, {
        key: 1,
        open: _ctx.configStore.loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["open"]))
}